import React from 'react';
import moment from 'moment';

import { Card, Table, Button, Popconfirm, message, Input, Icon } from 'antd';

import {
  _postPaginateAllExStock,
  _putRemoveProductFromExStock
} from '../../services'

class ProductExStockTable extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      data: [],
      count: 0,

      limit: 20,
      page: 1,

      title_search: '',
      supplier_search: '',
    
    }
  }

  render() {
    return (
      <Card title={false}>
        {this.renderSummary()}
        {this.renderTable()}
      </Card>
    )
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {

    const { 
      page, limit,
      title_search, supplier_search
    } = this.state
    
    _postPaginateAllExStock({ page, limit, title_search, supplier_search })
    .then(data => {
      console.log({data})
      this.setState({
        count: data.data.count,
        data: data.data.docs,
      })
    })
  }

  renderSummary = () => {
    const { count, title_search, supplier_search } = this.state

    return (
      <div style={{paddingBottom: 4}}>
        <div>Found <b>{count}</b> Product Ex Stock</div>
        <div>Title Search: <b>{title_search}</b></div>
        <div>Supplier Search: <b>{supplier_search}</b></div>
      </div>
    )
  }

  renderTable = () => {

    const { data } = this.state

    const columns = [{
      title: 'ProductId',
      dataIndex: '_id'
    },{
      title: 'Title',
      dataIndex: 'title',
      ...this.getColumnSearchProps('title'),
    },{
      title: 'SupplierId',
      dataIndex: 'supplierId'
    },{
      title: 'Supplier',
      dataIndex: 'supplier.details.companyName',
      ...this.getColumnSearchProps('supplier'),
    },{
      title: 'Date Added',
      dataIndex: 'dateCreated',
      render: (dateCreated) => moment(dateCreated).format('LL')
    },{
      title: 'Stock',
      dataIndex: 'stockCount',
    },{
      title: 'Actions',
      render: (_, record) => this.renderActions(record)
    }]

    return (
      <Table 
        onChange={this.handleTableChange}
        columns={columns}
        dataSource={data}
        pagination={{
          pageSize: this.state.limit,
          current: this.state.page,
          total: this.state.count,
          onChange: (nextPage) => {
              this.setState({ page: nextPage })
          }
        }}/>
    )
  }

  /* For column search */
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
                ref={node => {
                    this.searchInput = node;
                }}
                placeholder={`Search ${dataIndex}`}
                value={this.state[`${dataIndex}_search`]}
                // onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onChange={(e => this.setState({[`${dataIndex}_search`]: e.target.value}))}
                onPressEnter={() => this.handleSearch(confirm, dataIndex)}
                style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(confirm, dataIndex)}
                    icon='search'
                    size="small"
                    style={{ width: 90 }}
                >
                    Search
          </Button>
                <Button onClick={() => this.handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                    Reset
          </Button>
        </div>
    ),
    filterIcon: filtered => <Icon type='search' />,
    render: text => text
  });

  handleSearch = (confirm, dataIndex) => {
    confirm();
    // Page is set to 1 because if on handleSearch page==2 but results only has 1 page, cant see any results
    this.setState({
      page: 1
    }, this.getData)
  };

  handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    this.setState({
      [`${dataIndex}_search`]: ''
    }, this.getData);
  };

  renderActions = (record) => {
    return (
      <div>
        <Popconfirm
          title="Confirm removal of Ex Stock?"
          onConfirm={() => this.confirmRemoveFromExStock(record._id)}
          okText='Confirm'
          cancelText='No'>
          <Button type="danger" shape="circle" icon='close' size='small'  />
        </Popconfirm>
      </div>
    )
  }

  confirmRemoveFromExStock = (productId) => {

    if (productId === '' || !productId) {
      message.error('No product selected!')
      return
    }

    _putRemoveProductFromExStock({ productId })
    .then(data => {
      message.success(`${productId} successfully removed from Ex Stock!`)
      this.getData()
    })

  }

  handleTableChange = (pagination, filters, sorter, extra) => {

    this.setState({
        titleFilter: filters.title,
        supplierFilter: filters.supplier,
        current: pagination.current
    }, this.getData)
}

}

export default ProductExStockTable


// WEBPACK FOOTER //
// ./src/components/product-ex-stock/table.js